<template>
  <div id="app">
    <Header v-if="show"></Header>
    <router-view/>
    <Footer v-if="show"></Footer>
    <GoTop v-if="show"></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      show: true,
    };
  },
  mounted() {
     let router_path = this. $route.path
     if(router_path == '/questionnaires'){
       this.show = false
     }
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue